var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("travelService.chooseOfferForm.title")))]),
      _vm._l(_vm.allOffer.items, function(item, itemIndex) {
        return _c(
          "fieldset",
          {
            key: item.id,
            staticClass: "custom-fieldset",
            class: {
              "fieldset-warning":
                item.status ===
                _vm.itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL,
              "fieldset-error":
                item.status === _vm.itemsStatus.STATUS_BOOKING_CANCELLED
            }
          },
          [
            _c(
              "legend",
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("travelService.chooseOfferForm.service")) +
                    " " +
                    _vm._s(itemIndex + 1) +
                    " - " +
                    _vm._s(_vm.$t("travelService.types." + item.type)) +
                    " "
                ),
                item.status ===
                _vm.itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL
                  ? [
                      _vm._v(
                        " (" +
                          _vm._s(
                            _vm.$t(
                              "travelService.singleServiceOrderStatus.requestBookingCancel"
                            )
                          ) +
                          ") "
                      )
                    ]
                  : _vm._e(),
                item.status === _vm.itemsStatus.STATUS_BOOKING_CANCELLED
                  ? [
                      _vm._v(
                        " (" +
                          _vm._s(
                            _vm.$t(
                              "travelService.singleServiceOrderStatus.bookingCanceled"
                            )
                          ) +
                          ") "
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _c(
              "v-row",
              [
                item.selectedOffer.html != null &&
                item.selectedOffer.html.length !== 0
                  ? _c(
                      "v-col",
                      { attrs: { md: "10" } },
                      [
                        _c("w-y-s-i-w-y-g-html-element", {
                          attrs: { html: item.selectedOffer.html }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                item.type === "hotel" &&
                (item.selectedOffer.html == null ||
                  item.selectedOffer.html.length === 0)
                  ? _c(
                      "v-col",
                      { attrs: { md: "10", cols: "12" } },
                      [
                        _c("hotel-response-presentation", {
                          attrs: { offer: item.selectedOffer }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                item.type === "car" &&
                (item.selectedOffer.html == null ||
                  item.selectedOffer.html.length === 0)
                  ? _c(
                      "v-col",
                      { attrs: { md: "10", cols: "12" } },
                      [
                        _c("car-response-presentation", {
                          attrs: { offer: item.selectedOffer }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                item.type === "flight" &&
                (item.selectedOffer.html == null ||
                  item.selectedOffer.html.length === 0)
                  ? _c(
                      "v-col",
                      { attrs: { md: "10", cols: "12" } },
                      [
                        _c("flight-response-presentation", {
                          attrs: { offer: item.selectedOffer }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                item.type === "rail" &&
                (item.selectedOffer.html == null ||
                  item.selectedOffer.html.length === 0)
                  ? _c(
                      "v-col",
                      { attrs: { md: "10", cols: "12" } },
                      [
                        _c("rail-response-presentation", {
                          attrs: { offer: item.selectedOffer }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-col",
                  { staticClass: "pl-3", attrs: { md: "2", cols: "12" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t("global.amount"),
                        value:
                          item.selectedOffer.price +
                          " " +
                          item.selectedOffer.currency,
                        outlined: "",
                        readonly: ""
                      }
                    }),
                    _vm.$store.state.Auth.userProperties.system_settings
                      .cost_centre_on_delegations !==
                    _vm.settingTypes.NOT_AVAILABLE
                      ? _c("v-text-field", {
                          attrs: {
                            label: _vm.$t(
                              "travelService.chooseOfferForm.costCentreFullName"
                            ),
                            outlined: "",
                            readonly: ""
                          },
                          model: {
                            value: item.cost_centre,
                            callback: function($$v) {
                              _vm.$set(item, "cost_centre", $$v)
                            },
                            expression: "item.cost_centre"
                          }
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        staticClass: "text-center my-3",
                        staticStyle: { width: "100%" }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticStyle: { "font-size": "100px" },
                            attrs: { color: "primary" }
                          },
                          [_vm._v(_vm._s(_vm.bookingIconType(item.type)))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("travel-users-inline-form", {
              attrs: {
                "available-users": _vm.availableUsers,
                readonly: true,
                "required-props": _vm.getRequiredProps(item),
                users: item.users
              },
              on: {
                saved: function($event) {
                  return _vm.downloadAvailableUsers()
                }
              }
            }),
            item.selectedOffer.files.length > 0
              ? _c(
                  "fieldset",
                  { staticClass: "custom-fieldset" },
                  [
                    _c("legend", [
                      _vm._v(
                        _vm._s(_vm.$t("travelService.filesAttachedAtBooking"))
                      )
                    ]),
                    _c("multiple-file-download", {
                      attrs: { files: item.selectedOffer.files },
                      on: {
                        download: function(fileId) {
                          return _vm.downloadBookingFile(fileId)
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c("ClientViewOfferHistory", {
              attrs: { offers: [item.selectedOffer] }
            }),
            _c("message-list", {
              staticClass: "mb-3",
              attrs: {
                "travel-service-order-item-id": item.id,
                "travel-service-order-id": _vm.$route.params.id,
                "start-messages": item.messages
              }
            }),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("travelService.outdatedOffers")) + ":")
            ]),
            _vm._l(item.selectedOffer.history, function(historyItem) {
              return _c(
                "span",
                { key: historyItem.id },
                [
                  _c(
                    "offer-archive-dialog",
                    {
                      attrs: {
                        type: item.type,
                        id: historyItem.id,
                        "is-admin": false
                      }
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(historyItem.last_edit_at) +
                          " " +
                          _vm._s(historyItem.last_edit_by_name) +
                          " "
                      ),
                      _c(
                        "v-btn",
                        { attrs: { icon: "" } },
                        [_c("v-icon", [_vm._v("remove_red_eye")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            })
          ],
          2
        )
      }),
      !_vm.$store.getters["Ajax/loading"]
        ? _c(
            "h3",
            [
              _vm._v(" " + _vm._s(_vm.$t("global.sum")) + ": "),
              _vm._l(_vm.summaryDataTableCost, function(cost) {
                return [
                  _vm._v(
                    " " + _vm._s(cost.value) + " " + _vm._s(cost.currency) + " "
                  )
                ]
              }),
              _vm.summaryDataTableCost.length === 0
                ? [
                    _vm._v(
                      " 0. " +
                        _vm._s(
                          _vm.$t("travelService.noServicesSelectedToOrder")
                        ) +
                        " "
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _c(
        "v-card-actions",
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "blue darken-1", text: "" },
              nativeOn: {
                click: function($event) {
                  return _vm.cancel()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("global.cancel")))]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }